import React, {useState} from 'react'
import {connect} from "react-redux";
import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import {setSqftMeasureUnit} from "../../../../actions/sqftFunctions";
import {SQFT_MEASURE_UNIT} from "../../constants";
import {FormattedMessage} from "react-intl";
import {setMeasureUnit} from "../../helpers/sqftConfigHelper";

const SqftNavSettingsWindow = (props) => {

  const {activeButton, setSQFTActiveButton, measureUnit, setSqftMeasureUnit} = props;
  const [componentMeasureUnit, setComponentMeasureUnit] = useState(measureUnit);
  const expanded = activeButton === "settings";

  const handleChangeMeasureUnitClick = (componentMeasureUnit) => {
    setComponentMeasureUnit(componentMeasureUnit)
  };

  const handleSettingsClick = (isSave) => {
    if (isSave) {
      setSqftMeasureUnit(componentMeasureUnit);
      setMeasureUnit(componentMeasureUnit);
    } else {
      setComponentMeasureUnit(measureUnit)
    }

    setSQFTActiveButton("");
  };


  //debugger; // eslint-disable-line no-debugger
  // console.log("measureUnit", measureUnit);
  // console.log("componentMeasureUnit", componentMeasureUnit);

  return (
    <div className={"message-box-overlay-settings " + (expanded ? "" : "hidden")}>
      <div className="message-window-base">
        <div className="message-window-header-line">
          <div className="message-system-message-title message-system-message-title-settings"
               data-text="sqft.popup.settings.title">
            <FormattedMessage id={"sqft.popup.settings.title"}/>
          </div>
          <button className="button button--close button--cancel" data-popup-id="settings"
                  onClick={() => handleSettingsClick(false)}
                  data-action="close-popup">
          </button>
        </div>
        <div className="message-window-container">
          <div className="message-window-container-title message-window-text-gray">
            Units
          </div>
          <div className="message-window-container-text">
            <span className="settings-units">
              <div className="drop-down-list drop-down-list-visible">
                <span className="drop-down-list-item-container">
                  <span className={"drop-down-list-item " + (componentMeasureUnit === SQFT_MEASURE_UNIT.imperial ? "active" : "")} data-value="Imperial"
                        onClick={() => handleChangeMeasureUnitClick("Imperial")}
                        data-text="sqft.popup.settings.checkbox.imperial">
                    <FormattedMessage id={"sqft.popup.settings.checkbox.imperial"}/>
                  </span>
                  <span className={"drop-down-list-item " + (componentMeasureUnit === SQFT_MEASURE_UNIT.metric ? "active" : "")} data-value="Metric"
                        onClick={() => handleChangeMeasureUnitClick("Metric")}
                        data-text="sqft.popup.settings.checkbox.metric">
                    <FormattedMessage id={"sqft.popup.settings.checkbox.metric"}/>
                  </span>
                </span>
              </div>
            </span>
          </div>
        </div>
        <div className="message-box-buttons message-box-buttons--modal">
          <button className="ui-button10 ui-button10--green" data-popup-id="settings"
                  onClick={() => handleSettingsClick(true)}>
            <span className="ui-button10--uppercase"
                  data-text="sqft.popup.settings.saveButton">
              <FormattedMessage id={"sqft.popup.settings.saveButton"}/>
            </span>
          </button>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSqftMeasureUnit
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftNavSettingsWindow);
